import { fetchPopularAirports } from 'actions/FlightActions'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'
import { useAppDispatch } from 'hooks/reduxHooks'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import React, { ChangeEventHandler, ComponentProps, useCallback, useEffect, useRef, useState } from 'react'
import OfferAirportOptionsList from './OfferAirportOptionsList'
import TextInputOnly from 'components/Common/Form/Input/TextInputOnly'
import LineSearchIcon from 'LuxKit/Icons/line/LineSearchIcon'

interface Props extends Pick<ComponentProps<typeof DropdownList>, 'open' | 'anchorRef' | 'triggerRef'> {
  onClose: () => void
  onSelectAirport: (airport: App.AirportLocation) => void
  selectedAirportCode?: string
}

function OfferAirportSelectDropdown(props: Props) {
  const {
    open,
    anchorRef,
    triggerRef,
    onClose,
    onSelectAirport,
  } = props

  const inputRef = useRef<HTMLInputElement>(null)

  const dispatch = useAppDispatch()
  const isMobile = useScreenSizeOnly('mobile')

  useEffect(() => {
    if (open && !isMobile) {
      inputRef.current?.focus()
    }
  }, [isMobile, open])

  useEffect(() => {
    dispatch(fetchPopularAirports())
  }, [dispatch])

  const [searchPhrase, setSearchPhrase] = useState('')

  const handleSearchPhraseInputChange = useCallback<ChangeEventHandler<HTMLInputElement>>((event) => {
    setSearchPhrase(event.target.value)
  }, [])

  return <DropdownList
    size="M"
    open={open && !isMobile}
    anchorRef={anchorRef}
    triggerRef={triggerRef}
    title="Where will you depart from?"
    subtitle="Select your preferred airport"
    onClose={onClose}
    primaryActionProps={{
      children: 'Apply',
      onClick: onClose,
    }}
    headerExtension={<TextInputOnly
      placeholder="Search by city or airport"
      noValidationMessage
      noValidationSpacing
      onChange={handleSearchPhraseInputChange}
      endIcon={<LineSearchIcon />}
      ref={inputRef}
    />}
  >
    <OfferAirportOptionsList
      searchPhrase={searchPhrase}
      onSelectAirport={onSelectAirport}
    />
  </DropdownList>
}

export default React.memo(OfferAirportSelectDropdown)
